import { palettes } from "./palette";
import { defaultPalette } from "./palettes/default";

export const getThemeConfig = (theme: string) => {
  const palette = palettes[theme] || defaultPalette;

  const colorBorder = palette.Basic500;

  return {
    cssVar: true,
    token: {
      // fonts
      fontFamily: "TikTok Sans, sans-serif",

      fontSize: 15,
      lineHeight: 1.294,

      // colors
      colorTextHeading: palette.Basic900,
      colorWhite: palette.White,
      colorBlack: palette.Basic800,
      colorPrimary: palette.Primary100,
      colorPrimaryHover: palette.Primary100,
      colorPrimary300: palette.Primary300,
      colorPrimary500: palette.Primary500,
      colorMenuBg: palette.MenuBackground,
      colorHeaderBg: palette.HeaderBackground,
      colorHeaderBorder: palette.HeaderBorder,
      colorHeaderText: palette.HeaderText,
      colorHeaderTextSecondary: palette.HeaderTextSecondary,
      colorUserText: palette.UserText,
      colorUserTextSecondary: palette.UserTextSecondary,
      colorText: palette.Basic800,
      colorTextSecondary: palette.Basic700,
      colorTextTertiary: palette.Basic600,
      colorBorderSecondary: palette.Basic600,
      colorBorder: colorBorder,
      colorError: palette.Error,
      colorLinkHover: palette.Primary100,
      colorInfoBg: palette.Primary400,
      colorInfoText: palette.Basic600,
      colorInfo: palette.Blue,
      colorSuccess: palette.Success,
      colorWarning: palette.Warning,
      labelColor: palette.Basic600,
      colorSelectHover: palette.Gray2,
      colorTextPlaceholder: palette.Basic600,
      colorRadioButtonGrey: palette.Basic700,
      colorHeader: palette.nBasic800,

      colorBasic200: palette.nBasic200,
      colorBasic300: palette.nBasic300,
      colorBasic400: palette.nBasic400,
      colorBasic500: palette.nBasic500,
      colorBasic600: palette.nBasic600,
      colorBasic700: palette.nBasic700,
      colorBasic800: palette.nBasic800,
      colorBasic900: palette.nBasic900,

      // statuses color
      // работает только так
      "blue-7": palette.Blue,
      blue7: palette.Blue,
      "blue-3": palette.Blue3,
      blue3: palette.Blue3,
      "blue-1": palette.Blue1,
      blue1: palette.Blue1,
      "green-7": palette.Green,
      green7: palette.Green,
      "green-3": palette.Green3,
      green3: palette.Green3,
      "green-1": palette.Green1,
      green1: palette.Green1,
      "red-7": palette.Red,
      red7: palette.Red,
      "red-3": palette.Red3,
      red3: palette.Red3,
      "red-1": palette.Red1,
      red1: palette.Red1,
      yellow: palette.Attention300,

      //uikit
      purple: palette.Purple,
      "purple-2": palette.Purple2,
      purple2: palette.Purple2,
      purple3: palette.Purple3,

      // padding
      paddingMD: 16,

      // margin
      marginLG: 24,

      // heading
      fontSizeHeading1: 28,

      // border radius
      borderRadius: 12,
      borderRadiusSm: 4,

      // sizes
      radioRadioSize: 16,

      //status bar
      "prima-2": palette.Basic400, // status bar main text color
      "gray-3": palette.Gray5, // status bar secondary text color
    },
    components: {
      Layout: {
        headerBg: palette.Transparent,
        headerPadding: 0,
        bodyBg: palette.nBasic200,
        headerHeight: 80,
      },
      Select: {
        optionHeight: 34,
        optionFontSize: 13,
        // multipleItemBg: palette.Gray3,
        // optionPadding: 8,
        // colorBorder: colorBorder,
        controlOutline: "none",
        // colorBgContainer: palette.Basic100,
        colorText: palette.Basic800,
        // selectorBg: palette.Basic100,
        // hoverBorderColor: palette.Basic600,
        borderColor: colorBorder,
        activeBorderColor: colorBorder,
        hoverBorderColor: colorBorder,
        hoverBg: palette.White,
        focusBg: palette.White,
      },
      DatePicker: {
        paddingInline: 12,
        // colorBgContainer: palette.Basic100,
        colorText: palette.Basic800,
        borderColor: colorBorder,
        activeBorderColor: colorBorder,
        hoverBorderColor: colorBorder,
        // cellActiveWithRangeBg: palette.Primary100,
      },
      Input: {
        paddingInline: 12,
        colorBorder: colorBorder,
        activeBorderColor: colorBorder,
        colorBgContainer: palette.White,
        colorText: palette.Basic800,
        hoverBg: palette.White,
        activeBg: palette.White,
        focusBg: palette.White,
        hoverBorderColor: colorBorder,
        activeShadow: "none",
      },
      Button: {
        paddingInline: 24,
        paddingInlineSM: 16,
        controlHeight: 40,
        controlHeightSM: 32,
        paddingBlock: 19,
        paddingBlockSM: 12,
        borderRadius: 28,
        borderRadiusSM: 56,
        defaultBg: palette.Transparent,
        defaultHoverBg: palette.Gray4,
        defaultBorderColor: palette.Basic400,
        defaultHoverBorderColor: palette.Basic400,
        defaultColor: palette.Basic800,
        defaultHoverColor: palette.Basic800,
        fontWeight: 500,
        contentFontSize: 16,
      },
      Divider: {
        verticalMarginInline: 5,
      },
      Menu: {
        itemBg: palette.Transparent,
        itemSelectedBg: palette.Primary200,
        itemHoverBg: palette.Basic800,
        colorSplit: palette.Transparent,
        horizontalItemBorderRadius: 20,
        horizontalItemHoverBg: palette.Transparent,
        horizontalItemHoverColor: palette.MenuText,
        horizontalItemSelectedBg: palette.MenuItemSelectedBg,
        horizontalItemSelectedColor: palette.MenuTextSelected,
        horizontalLineHeight: 40,
        itemColor: palette.MenuText,
        itemSelectedColor: palette.MenuTextSelected,
        itemHoverColor: palette.MenuText,
        activeBarHeight: 0,
        itemPaddingInline: 30,
      },
      Collapse: {
        headerBg: palette.White,
        colorBorder: palette.Basic500,
        headerPadding: 32,
        contentPadding: "0px 32px 32px 32px",
      },
      Tag: {
        defaultBg: palette.Gray1,
        defaultColor: palette.Gray,
        colorBorder: palette.Gray3,
        fontSizeSm: 11,
      },
      Pagination: {
        itemActiveBg: palette.Basic800,
        borderRadius: 4,
      },
      Radio: {
        radioRadioBgColor: palette.Basic800,
        colorPrimary: palette.Basic800,
        buttonColor: palette.Basic800,
        buttonSolidCheckedHoverBg: palette.Basic800,
        wrapperMarginInlineEnd: 10,
        buttonPaddingInline: 12,
      },
      Card: {
        padding: 40,
        colorBorderSecondary: palette.Transparent,
      },
      Form: {
        itemMarginBottom: 16,
      },
      Typography: {
        titleMarginBottom: "0.6em",
      },
      Table: {
        headerBg: palette.Transparent,
        headerSplitColor: palette.Transparent,
        cellPaddingBlock: 16,
        cellPaddingInline: 12,
        headerColor: palette.Basic700,
        bodySortBg: palette.Basic200,
        headerSortActiveBg: palette.Basic200,
        stickyScrollBarBg: palette.Transparent,
        stickyScrollBarBorderRadius: 0,
        borderColor: palette.Basic300,
      },
      Tabs: {
        itemColor: palette.Basic800,
        itemSelectedColor: palette.Basic800,
        titleFontSize: 15,
        horizontalItemPadding: "8px 12px",
        horizontalItemGutter: 8,
        inkBarColor: palette.Transparent,
      },
      Badge: {
        dotSize: 8,
      },
      Checkbox: {
        borderRadiusSm: "4px",
        colorBorder: colorBorder,
        colorPrimary: palette.Basic800,
      },
    },
  };
};
